import React from 'react';
import { Button, Popover, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import EditPollingServiceModal from '../modals/EditPollingServiceModal'
import DeletePollerModal from '../modals/DeletePollerModal'
import { connect } from 'react-redux'
import MoreVert from '../../images/sharp-more_vert-24px.svg'
import { Flag } from 'flagger/react'
import { withAlert } from 'react-alert';

class PollerPopoverItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            popoverOpen: false,
            modal: false,
            editmodal: false,
            deleteModal: false,
            associated: false
        };

        this.toggle = this.toggle.bind(this);
        this.editdocument = this.editdocument.bind(this);
        this.toggleEditModal = this.toggleEditModal.bind(this);
        this.toggleDeleteDocument = this.toggleDeleteDocument.bind(this)
    }


    toggle() {
        this.setState({
            popoverOpen: !this.state.popoverOpen
        });
    }

    componentDidUpdate(prevProps) {
    }

    toggleDeleteDocument() {
        this.setState({
            deleteModal: !this.state.deleteModal,
            popoverOpen: false
        });
    }

    editdocument() {
        this.toggle();
        this.toggleEditModal();

    }

    toggleEditModal() {
        try {
            this.setState({
                editmodal: !this.state.editmodal,
                popoverOpen: false

            });
        }
        catch (error) {
            console.error(error)
        }
    }

    render() {
        const { localisation } = this.props.userReducer;

        //seperate style for hidden input.
        var style = {};
        style.display = 'none';
        let popoverItems = []
        const { id, fileid } = this.props;
        let tick = <div />


        let editPollerModalPopup = {}
        let deletePollerModal = {}

        popoverItems.push(<a class="s-list-default-btn-default s-popup-menu-no-icon" onClick={this.editdocument} title="Edit"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-create" /> {localisation['popover_edit'] ? localisation['popover_edit'].element_lang : ''}</a>)
        popoverItems.push(<a class="s-list-default-btn-default s-with-icon" onClick={this.toggleDeleteDocument} title="Delete"><div class="s-list-default-btn-default-icon s-mn-icontext s-fonticon-btn s-btn-delete"></div> {localisation['popover_delete'] ? localisation['popover_delete'].element_lang : ''}</a>)

        if (this.state.editmodal)
            editPollerModalPopup = <EditPollingServiceModal refresh={this.props.refresh} visible={this.state.editmodal} toggle={this.toggleEditModal} destination={fileid} type={this.props.type} />
        else
            editPollerModalPopup = <div />

        if (this.state.deleteModal) {
            deletePollerModal = <DeletePollerModal modal={this.state.deleteModal} refresh={this.props.refresh} toggle={this.toggleDeleteDocument} destination={fileid} name={this.props.filename} type={this.props.type} />
        }
        else
            deletePollerModal = <div />

        return (
            <span>
                {tick}
                <Flag flag="v12" entity={{ id: 1 }} case="off">
                    <Button className="s-record-picker s-fonticon-btn s-btn-menus" color="secondary" id={id} onClick={this.toggle}>
                        ?
                    </Button>
                </Flag>
                <Flag flag="v12" entity={{ id: 1 }} case="on">
                    <Button className="s-record-picker s-fonticon-btn s-btn-menus" color="secondary" id={id} onClick={this.toggle}>
                        <img src={MoreVert} />
                    </Button>
                </Flag>
                <Popover placement="top" hideArrow={true} isOpen={this.state.popoverOpen} target={id} toggle={this.toggle}>
                    {popoverItems}
                </Popover>
                {deletePollerModal}
                {editPollerModalPopup}
            </span>
        );
    }
}

export default connect(state => state)(PollerPopoverItem);